import { render, staticRenderFns } from "./WorkcenterList.vue?vue&type=template&id=61210f9e&scoped=true&"
import script from "./WorkcenterList.vue?vue&type=script&lang=js&"
export * from "./WorkcenterList.vue?vue&type=script&lang=js&"
import style0 from "./WorkcenterList.vue?vue&type=style&index=0&id=61210f9e&lang=scss&scoped=true&"
import style1 from "./WorkcenterList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61210f9e",
  null
  
)

export default component.exports